<template>
  <div class="modal-mask" v-if="isShowModal">
    <div class="popup on">
      <div class="prePop">
        <div class="prePop_wrap">
          <div class="prePop_contents">
            <div class="prePop_cont_area">
              <div class="prePop_top">
                <p class="popimg02"></p>                
                <p v-html="message"></p>
              </div>
              <div class="prePop_txt">
                <div class="prePopfooter">
                  <div v-if="isConfirm" class="cell" @click="confirm">
                    <a href="javascript:void(0);">확인</a>
                  </div>
                  <div v-if="isConfirm" class="cell" @click="cancel">
                    <a href="javascript:void(0);">취소</a>
                  </div>                              
                  <div v-else class="cell" @click="close">
                    <a href="javascript:void(0);">확인</a>
                  </div>
                </div>
              </div>
            </div>
            <a href="javascript:void(0);" @click="close" class="btn_prePop_close" title="닫기">닫기</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    methods: {
      confirm : function() {
        this.isShowModal = false;

        if( typeof this.callback == 'function' ) {
          this.callback(true);
        }
      },
      cancel : function() {
        this.isShowModal = false;

        if( typeof this.callback == 'function' ) {
          this.callback(false);
        }
      },      
      close: function() {
        this.isShowModal = false;

        if( typeof this.callback == 'function' ) {
          this.callback();
        }
      }
    },
    data() {
      return {
        isShowModal: false,
        isConfirm: false,
        title: '알림',
        message: ''
      }
    }
  }
</script>

<style scoped>
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .7);
    display: table;
    transition: opacity .3s ease;
  }
</style>






// WEBPACK FOOTER //
// src/modules/template/AlertTemplate.vue